import { render, staticRenderFns } from "./NavigationFrame.vue?vue&type=template&id=66ee32a0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./NavigationFrame.vue?vue&type=script&lang=js&"
export * from "./NavigationFrame.vue?vue&type=script&lang=js&"
import style0 from "./NavigationFrame.vue?vue&type=style&index=0&id=66ee32a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee32a0",
  null
  
)

export default component.exports